import React from "react";

const ShiftRosterIcon20pxSvg = ({ color = "#718096" }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.9583 2.96602V1.66602C13.9583 1.32435 13.675 1.04102 13.3333 1.04102C12.9917 1.04102 12.7083 1.32435 12.7083 1.66602V2.91602H7.29165V1.66602C7.29165 1.32435 7.00832 1.04102 6.66665 1.04102C6.32499 1.04102 6.04165 1.32435 6.04165 1.66602V2.96602C3.79165 3.17435 2.69999 4.51602 2.53332 6.50768C2.51665 6.74935 2.71665 6.94935 2.94999 6.94935H17.05C17.2917 6.94935 17.4917 6.74102 17.4667 6.50768C17.3 4.51602 16.2083 3.17435 13.9583 2.96602Z"
                fill={color}
            />
            <path
                d="M16.6667 8.19922H3.33333C2.875 8.19922 2.5 8.57422 2.5 9.03255V14.1659C2.5 16.6659 3.75 18.3326 6.66667 18.3326H13.3333C16.25 18.3326 17.5 16.6659 17.5 14.1659V9.03255C17.5 8.57422 17.125 8.19922 16.6667 8.19922ZM7.675 15.1742C7.59167 15.2492 7.5 15.3076 7.4 15.3492C7.3 15.3909 7.19167 15.4159 7.08333 15.4159C6.975 15.4159 6.86667 15.3909 6.76667 15.3492C6.66667 15.3076 6.575 15.2492 6.49167 15.1742C6.34167 15.0159 6.25 14.7992 6.25 14.5826C6.25 14.3659 6.34167 14.1492 6.49167 13.9909C6.575 13.9159 6.66667 13.8576 6.76667 13.8159C6.96667 13.7326 7.2 13.7326 7.4 13.8159C7.5 13.8576 7.59167 13.9159 7.675 13.9909C7.825 14.1492 7.91667 14.3659 7.91667 14.5826C7.91667 14.7992 7.825 15.0159 7.675 15.1742Z"
                fill={color}
            />
        </svg>
    );
};

export default ShiftRosterIcon20pxSvg;